import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-link-prompt',
  templateUrl: './link-prompt.component.html',
  styleUrls: ['./link-prompt.component.scss']
})
export class LinkPromptComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
